/** ListBox scalar иногда приходит как dump каталога — не выбранный code. */

export function listboxCatalogRowLooksLike(x: unknown): boolean {
  if (x == null || typeof x !== 'object' || Array.isArray(x)) return false
  const r = x as Record<string, unknown>
  if (r.fields && typeof r.fields === 'object' && !Array.isArray(r.fields)) {
    const f = r.fields as Record<string, unknown>
    const pick = (k: string) => {
      const cell = f[k]
      if (cell && typeof cell === 'object' && !Array.isArray(cell) && 'value' in cell) {
        return (cell as { value: unknown }).value
      }
      return cell
    }
    const code = pick('code') ?? pick('_id')
    const title = pick('name') ?? pick('description')
    return (code != null && String(code) !== '') || (title != null && String(title) !== '')
  }
  return (
    ('code' in r || '_id' in r || 'usersHaveAccess' in r) &&
    ('name' in r || 'description' in r)
  )
}

export function isLikelyListboxFullItemsArray(v: unknown): boolean {
  if (!Array.isArray(v) || v.length < 2) return false
  return v.slice(0, 3).every(listboxCatalogRowLooksLike)
}

export function isLikelyListboxItemsStringDump(v: unknown): boolean {
  if (typeof v !== 'string') return false
  const t = v.trim()
  if (t.length < 60 || !t.includes('=>')) return false
  const hasKey = t.includes("'code'") || t.includes('"code"') || t.includes('_id')
  const hasTitle = t.includes("'name'") || t.includes("'description'") || t.includes('"name"')
  return hasKey && hasTitle
}

export function isLikelyListboxTablePayload(v: unknown): boolean {
  if (v == null || typeof v !== 'object' || Array.isArray(v)) return false
  const rows = (v as { rows?: unknown }).rows
  if (!Array.isArray(rows) || rows.length < 2) return false
  return rows.slice(0, 3).every(listboxCatalogRowLooksLike)
}

export function isListboxCatalogLikeScalar(v: unknown): boolean {
  if (v == null) return false
  return (
    isLikelyListboxItemsStringDump(v) ||
    isLikelyListboxFullItemsArray(v) ||
    isLikelyListboxTablePayload(v)
  )
}

/** Каталог/dump → пустой scalar; иначе значение как есть. */
export function sanitizeListboxScalarValue(raw: unknown): unknown {
  if (raw == null) return raw
  if (isListboxCatalogLikeScalar(raw)) return ''
  if (typeof raw === 'object' && !Array.isArray(raw) && raw !== null && 'value' in raw) {
    return sanitizeListboxScalarValue((raw as { value: unknown }).value)
  }
  if (typeof raw === 'object' && !Array.isArray(raw) && raw !== null) {
    const o = raw as Record<string, unknown>
    if (isLikelyListboxTablePayload(o)) return ''
    if (o.code != null || o._id != null) {
      const code = o.code ?? o._id ?? ''
      if (!isListboxCatalogLikeScalar(code)) return code
      return ''
    }
  }
  return raw
}
